import { render, staticRenderFns } from "./UtilityBill.vue?vue&type=template&id=fffe1652"
import script from "./UtilityBill.vue?vue&type=script&lang=js"
export * from "./UtilityBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports